import React from 'react'
import {
  useGlobalLabels,
  UseShippingAddressResult,
} from '@sentecacommerce-theme/lib'
import { Medium, OfficeOrAddressContainer, Ellipsis } from '../../'
import { Typography } from '../../../../'

interface Props {
  data: UseShippingAddressResult
}

export const AddressPreviewGeneric = ({ data }: Props) => {
  const { address, nr } = useGlobalLabels()

  const getInfo = (isQuarter = false) => {
    let result = ' '

    if (isQuarter && data?.streetLabel) {
      if (data?.building) {
        result += ` ${nr}${data.building}`
      }

      return result
    }

    if (!isQuarter && data?.building && !data?.quarterLabel) {
      result += ` ${nr}${data.building}`
    }

    if (data?.streetNumber) {
      result += ` ${nr}${data.streetNumber}`
    }

    if (data?.entrance) {
      result += data.entrance
    }

    if (data?.floor) {
      result += ` ${address?.et} ${data.floor}`
    }

    if (data?.apartment) {
      result += `${address?.ap} ${data.apartment}`
    }
    return result
  }
  return (
    <>
      <Medium>{`${address?.label}:`}</Medium>
      <OfficeOrAddressContainer>
        <Typography>{`${data?.cityLabel}`}</Typography>
        {Boolean(data?.quarterLabel) && (
          <>
            <Typography>{`${data?.quarterLabel} ${getInfo(true)}`}</Typography>
          </>
        )}
        {Boolean(data?.streetLabel) && (
          <>
            <Ellipsis>{`${data?.streetLabel} ${getInfo()}`}</Ellipsis>
          </>
        )}
        {Boolean(data?.additionalAddressInfo) && (
          <Ellipsis>* {data?.additionalAddressInfo}</Ellipsis>
        )}
        {data.isDefaultShippingAddress && (
          <div>
            <Medium>{address?.mainAddress}</Medium>
          </div>
        )}
      </OfficeOrAddressContainer>
    </>
  )
}
